import { createContext, useRef, useState, useEffect, useCallback } from "react";

export const MyContext = createContext({});

const getInitialTheme = () => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return "light";
  const stored = window.localStorage.getItem("dn-theme");
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
};

export const MyContextProvider = ({ children }) => {
  const [theme, setTheme] = useState(getInitialTheme);

  const serviceRef = useRef();
  const contactUsRef = useRef();
  const appointmentRef = useRef();
  const aboutUsRef = useRef();
  const processRef = useRef();

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    window.localStorage.setItem("dn-theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  return (
    <MyContext.Provider
      value={{
        serviceRef,
        contactUsRef,
        appointmentRef,
        aboutUsRef,
        processRef,
        theme,
        toggleTheme,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
